import React, { useEffect } from 'react';
// import ReactGA from 'react-ga4';

const Step7 = ({ formData, handleInputChange, setStep }) => {
  useEffect(() => {
    // const pageName = 'Step7';
    // ReactGA.event({
    //   category: 'Navigation',
    //   action: 'Page View',
    //   page_name: pageName
    // });
    sessionStorage.setItem('lastPage', 'Step7');
  }, []);

  const handleFormSubmit = (answer) => {
    handleInputChange({ target: { name: 'alcohol', value: answer === 'yes' } });
    setStep(9);
  };

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">ステップ 7</h2>
      <p className="text-base mb-4 text-lg">毎日飲酒をしていますか？<br />
        <br />※毎日の飲酒量が以下のいずれかに当てはまる場合は、「はい」を選んでください。<br />
        <span className="underline-wavy text-red-500">※不明な場合は、「いいえ」を選んでください。</span>
      </p>
      <br />
        <ul className="text-regular text-lg list-disc list-inside mb-5">
          <li>標準的なグラス(285ml)でビールを3杯以上</li>
          <li>蒸留酒のシングル(30ml)を3杯以上</li>
          <li>グラスワイン(120ml)を3杯以上</li>
          <li>日本酒約1合以上</li>
        </ul>
      <div className="flex justify-between">
        <button 
          onClick={() => setStep(7)} 
          className="bg-gray-500 text-white p-2 rounded hover:bg-gray-600 w-auto"
        >
          前の画面へもどる
        </button>
        <button 
          onClick={() => handleFormSubmit('yes')} 
          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 w-auto"
        >
          はい
        </button>
        <button 
          onClick={() => handleFormSubmit('no')} 
          className="bg-pink-500 text-white p-2 rounded hover:bg-pink-600 w-auto"
        >
          いいえ
        </button>
      </div>
    </div>
  );
};

export default Step7; 